import { render, staticRenderFns } from "./watch.vue?vue&type=template&id=0b3f6d03&scoped=true&"
import script from "./watch.vue?vue&type=script&lang=js&"
export * from "./watch.vue?vue&type=script&lang=js&"
import style0 from "./watch.vue?vue&type=style&index=0&id=0b3f6d03&lang=scss&scoped=true&"
import style1 from "./watch.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f6d03",
  null
  
)

export default component.exports